import React from 'react';
import styled from 'styled-components';

// ImageContainer now accepts a prop 'backgroundImage' to set the background dynamically
const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  margin: 5px 0 0 0 ;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  background-image: url(${props => props.backgroundImage});
  background-color: transparent; 
  ${'' /* background-size: 99%;  */}
  background-size: cover;
  background-position: Center;
  background-repeat: no-repeat;
  border-radius: 15px;
  padding: 20px;
  box-sizing: border-box;
  border: 2px solid white;
`;

const StaticImage = ({ backgroundImage }) => {
  return (
    <ImageContainer backgroundImage={backgroundImage}>
    </ImageContainer>
  );
};

export default StaticImage;
